<template>
	<div class="import-shop-products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Delete Products</h1>

		<p class="description">
			This will delete the products from CSV.
		</p>

		<b-field class="file">
			<label class="csv-reader">
				<input type="file" @change="loadTextFromFile" />
			</label>
		</b-field>

		<div v-if="successCode" class="delete-success">DELETING: {{ currentCount }} {{ successCode }}</div>

		<div v-if="deleteErr.length > 0" class="delete-error">
			<div v-for="(data, key) of deleteErr" :key="key">Error: {{ data }}</div>
		</div>

		<div class="button-container">
			<div v-if="confirmation">
				<br />
				<p>ARE YOU SURE YOU WANT TO DELETE THESE PRODUCTS?</p>
				<br />
				<br />
				<div class="big-button" @click="deleteConfirm()" v-if="!isLoading">
					CONFIRM!
				</div>
				<div class="big-button big-button-loading" v-else>
					DELETING
				</div>
			</div>

			<div class="big-button" v-if="!confirmation" @click="confirmFirst()">
				DELETE PRODUCTS
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DeleteOrders',
	data: () => ({
		isLoading: false,
		content: [],
		deleteErr: [],
		successCode: '',
		confirmation: false,
		currentCount: 0
	}),

	computed: {},

	mounted: async function() {},

	watch: {},

	methods: {
		confirmFirst() {
			this.confirmation = true
		},

		loadTextFromFile(ev) {
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				// Remove first row
				raw.shift()

				console.log(raw)

				const newObj = {}
				// Loop every row to put it in array
				raw.map(async data => {
					var splitData = data.split(/,/)

					if (!newObj[splitData[0]]) {
						this.$set(newObj, splitData[0], [])
					}

					newObj[splitData[0]].push(splitData[1])
				})

				this.content = newObj
			}

			reader.readAsText(file)
		},

		deleteConfirm: async function() {
			this.isLoading = true
			if (this.content) {
				this.deleteErr = []

				const dataArray = []
				for (const bdCode in this.content) {
					dataArray.push(bdCode.trim())
				}

				for (const bdCode of dataArray) {
					this.currentCount++
					if (bdCode) {
						var data = {
							bdCode: bdCode
						}
						const deleteProduct = await this.$api.productDelete({
							data
						})
						if (deleteProduct.status == '201' && deleteProduct.data.error) {
							this.deleteErr.push({ bdCode, error: deleteProduct.data.error })
						} else {
							this.successCode = bdCode
						}
					}
				}

				// export csv for error products
				if (this.deleteErr.length > 0) {
					let finalData = 'BD CODE\r\n'

					// total_products.map(p => {
					for (const err of this.deleteErr) {
						let toAdd = []

						toAdd = [err.bdCode, err.error]

						let row = toAdd.join(',')

						finalData += row + '\r\n'
					}

					var csvData = new Blob([finalData], { type: 'text/csv' })
					var csvUrl = URL.createObjectURL(csvData)

					let filename_date = this.$moment().format('DDMMYYhhmmss')

					var link = document.createElement('a')
					link.setAttribute('href', csvUrl)
					link.setAttribute('download', 'product_delete_error_' + filename_date + '.csv')
					document.body.appendChild(link) // Required for FF

					link.click()
					link.remove()
				}

				this.$swal.fire('Finished!')
			}

			this.confirmation = false

			this.isLoading = false
		},

		deleteProducts: async function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				})
				.then(async result => {
					if (result.isConfirmed) {
						await this.deleteConfirm()
					}
				})
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';

.big-button-loading {
	background-color: #eee;
}

.delete-success {
	text-align: center;
	color: 'green';
	font-weight: bold;
	font-size: 16px;
	margin: 1em 0;
}

.delete-error {
	text-align: center;
	color: #ff0000;
	font-weight: bold;
	margin: 1em 0;
}

.button-container p {
	font-weight: bold;
	font-size: 16px;
}
</style>
